import {
  EChatSetor,
  getKeyFromValue,
  IChatGroup,
  IMensagem,
} from "@deltasge/marauders-map";
import { LinearProgress, ListSubheader as ListSub } from "@mui/material";
import { snack } from "components/GlobalSnackbar";
import { api } from "configs";
import React, { FC, useEffect, useState } from "react";
import { useAppSelector } from "store";
import { getError } from "utils";

export const ListSubheader: FC<{ group: IChatGroup }> = ({ group }) => {
  const { usuario } = useAppSelector((state) => state.usuario);
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState(
    group.idSetor
      ? getKeyFromValue(EChatSetor, group.idSetor)
      : (group.chatUsers || [])
          .map((user) =>
            user.deltaId == usuario?.deltaId ? "Você" : user.nome
          )
          .join(", ")
  );

  useEffect(() => {
    (async () => {
      try {
        if (group.idMensagem) {
          setLoading(true);
        }
        const { data } = await api.get<IMensagem | undefined>(
          `educador/mensagem/${group.idMensagem}`,
          {
            params: {
              select: [
                "id",
                "titulo",
                "mensagemCategoria",
                "mensagemCategoria.nome",
                "mensagemCategoria.id",
              ],
            },
          }
        );
        if (data?.titulo) setTitle(data.titulo);
        else if (data?.mensagemCategoria?.nome)
          setTitle(data.mensagemCategoria.nome);
      } catch (error) {
        snack.error(getError(error));
      } finally {
        setLoading(false);
      }
    })();
  }, [group.idMensagem]);

  return (
    <ListSub component="div" id="nested-list-subheader">
      {loading && <LinearProgress />}
      {!loading && title}
    </ListSub>
  );
};
